import { queryOptions } from "@tanstack/react-query";
import { axiosInstance } from "./axios";
import { z } from "zod";

const playerStatsSchema = z.object({
    playerId: z.number(),
    firstName: z.string(),
    lastName: z.string(),
    percentage: z.number(),
});

const quickStatsSchema = z.object({
    shotsAccuracy: z.array(playerStatsSchema),
    saves: z.array(playerStatsSchema),
    puckContestWin: z.array(playerStatsSchema),
    corsi: z.array(playerStatsSchema),
    fenwick: z.array(playerStatsSchema),
    faceoffWin: z.array(playerStatsSchema),
});

export type QuickStats = z.infer<typeof quickStatsSchema>;

const fetchQuickStats = async (tournamentId: number, teamId?: number): Promise<QuickStats> => {
    try {
        const response = await axiosInstance.get(`/${tournamentId}/${teamId ?? 0}/analysis/quick-stats`);
        return quickStatsSchema.parse(response.data);
    } catch (error) {
        throw new Error(`Failed to fetch quick stats details: ${error}`);
    }
};

export const quickStatsQueryOptions = (tournamentId: number, teamId?: number) =>
    queryOptions({
        queryKey: ["quick-stats", tournamentId, teamId],
        queryFn: () => fetchQuickStats(tournamentId, teamId),
        staleTime: 5 * 60 * 1000,
    });
